import { environment } from '@env/environment';

export async function remove(key: string, prefix?: string): Promise<void> {
  // @ts-ignore
  const appKey = environment.values['storage-key'];
  if (prefix) key = `${appKey}:${prefix}:${key}`;
  else key = `${appKey}:${key}`;
  return localStorage.removeItem(key);
}
